import React from "react";
import { LeftHeader } from "../header";
import { useTheme } from "../../context/useThemeContext";
import Footer from "./footer";
import SortSelector from "./sortSelector";
import NotesContainer from "./notes/notesContainer";
import FoldersContainer from "./folders/foldersContainer";
import useMainStore from "../../stores/mainStore";
import { CustomScrollBox } from "../../components/customScrollBox";
import useAbsoluteWindowStore from "../../stores/absoluteWindowStore";
import LeftScrollboxContextMenu from "../contextMenu/contextMenus/leftScrollboxContextMenu";

function LeftSidebar() {
    const { theme } = useTheme();
    const selectedFolderID = useMainStore(
        (state) => state.data.selectedFolderID
    );

    function rightClick(e: React.MouseEvent) {
        useAbsoluteWindowStore.getState().setWindowShowing({
            type: "ContextMenu",
            children: <LeftScrollboxContextMenu />,
        });

        useAbsoluteWindowStore.getState().setPosition(e.clientX, e.clientY);
    }

    return (
        <div
            className="flex flex-col flex-1 "
            style={{
                height: "inherit",
            }}
        >
            <LeftHeader />
            <div
                className="flex flex-1 flex-col"
                style={{
                    backgroundColor: theme.leftSidebarColor,
                }}
            >
                <SortSelector />
                <div className="flex flex-1 relative">
                    <CustomScrollBox
                        $handleColor={theme.headerColor}
                        $handleColorActive={theme.accentColor}
                        className="flex flex-1 overflow-hidden relative flex-col"
                        style={{
                            position: "absolute",
                            top: "0px",
                            bottom: "0px",
                            left: "6px",
                            right: "6px",
                        }}
                        onContextMenu={(e) => {
                            e.preventDefault();
                            rightClick(e);
                        }}
                    >
                        {!selectedFolderID && <FoldersContainer />}
                        {selectedFolderID && <NotesContainer />}
                    </CustomScrollBox>
                </div>

                <Footer />
            </div>
        </div>
    );
}

export default LeftSidebar;
